const PROJECT_ID = '6u6ni7vk';
const DATASET = 'production';
const API_VERSION = '2024-01-01';

/**
 * Execute a GROQ query against the Sanity API using native fetch.
 * This avoids CORS issues that can occur with the @sanity/client library.
 */
async function sanityFetch(query, params = {}) {
  const encodedQuery = encodeURIComponent(query);
  let url = `https://${PROJECT_ID}.api.sanity.io/v${API_VERSION}/data/query/${DATASET}?query=${encodedQuery}&returnQuery=false&perspective=published`;

  // Append params as query string
  Object.entries(params)?.forEach(([key, value]) => {
    url += `&$${key}=${encodeURIComponent(JSON.stringify(value))}`;
  });

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response?.ok) {
    throw new Error(`Sanity API error: ${response.status} ${response.statusText}`);
  }

  const json = await response?.json();
  return json?.result;
}

const sanityClient = {
  fetch: sanityFetch,
};

export default sanityClient;
